/**
 * ---------------------------------------------------------
 *
 * 	HomePage with a logo.
 * 
 * ----------------------------------------------------------
 */

import React from 'react';
import PermanentDrawerLeft from '../../components/PermanentDrawerLeft';
import logo from "../../assets/logo.png"
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({

  content: {
    paddingLeft: '280px',
    paddingTop: '100px',
    textAlign: 'center'
  },
  img: {
    width: '60%',
  }
}));

function PanelHomePage() {
  const classes = useStyles();
  return (
    <div>
      <PermanentDrawerLeft></PermanentDrawerLeft>
      <main className={classes.content}>
        <div>
          <img src={logo} alt="logo" className={classes.img} />
        </div>
      </main>
    </div>
  );
}

export default PanelHomePage;